<template>
  <div >
    <!--  <van-field v-model="selectValue" :placeholder="placeholder" type="text" :label="label" :is-link="isLink" :readonly="readonly"
      @focus="onFocus" />
    <div class="van-hairline--bottom"></div>
    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" name="abc" :title="title" /> -->
    <van-field :readonly="readonly" :clickable="clickable" name="calendar" :value="value" :label="label"
      :placeholder="placeholder" @click="showPicker = true"  :required="required" :rules="[{ required: required, message: label+'不可为空' }]">
       <template #button>
         <van-icon v-show="closeabled" name="close" @click.stop="clearValue" />
          <!-- <van-button size="small" type="primary">发送验证码</van-button> -->
        </template>
    </van-field>
    <van-popup v-model="showPicker" position="bottom">
      <!-- <van-calendar v-model="showCalendar" :min-date="minDate" :max-date="maxDate" @confirm="onConfirm" /> -->
      <van-datetime-picker v-model="selectValue" type="date" title="选择年月日" :min-date="minDate" :max-date="maxDate"
        @confirm="onConfirm" @cancel="showPicker = false"/>
    </van-popup>
  </div>
</template>

<script>
  export default {
    name: 'DataSelect',
    props: {
      label: {
        type: String,
        default: '未定义'
      },
      placeholder: {
        type: String,
        default: '点击选择日期'
      },
      value: {
        default: ''
      },
      // 是否必填
			required: {
				type: Boolean,
				default: false
			},
      //timeMode 目前暂定模式如下
      //new,最小年从当前年年-01-01开始
      //now,从当前时间开始
      //"" ,从1990年开始，主要考虑出生日期
      //defalutYear,最小年设置默认年，和yearDiff搭配使用
      timeMode: {
        type: String,
        default: ""
      },
      //相差年，和timeMode的defalutYear模式对应
      yearDiff: {
        type: Number,
        default: 0
      },
      timeNow: {
        type: Boolean,
        default: false
      },
      closeabled:{
        type: Boolean,
        default: false
      }

    },
    data() {
      return {
        form: {
          token: ''
        },
        selectValue: this.value? new Date(this.value) : new Date(1970, 6, 1),
        readonly: true,
        clickable: true,
        showPicker: false,
        minDate: new Date(1930, 0, 1),
        maxDate: new Date(2025, 12, 31),
      }
    },
    watch: {
      value(newVal) {
        if (newVal) {
          this.selectValue = new Date(newVal)
        }
      }
    },
    methods: {
      onConfirm(date) {
        this.showPicker = false;
        let month = date.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        let day = date.getDate();
        if (day < 10) {
          day = "0" + day;
        }
        let dataStr = `${date.getFullYear()}-${month}-${day}`;
        this.$emit('input', dataStr)
        // this.selectValue = `${date.getFullYear()}-${month}-${day}`;
        // this.$emit('input', this.selectValue)
      },
      //设置默认时间和时间范围
      setTimeRange() {
        let that = this
        //获得当前时间年
        let nowDate = new Date()
        let nowYear = nowDate.getFullYear()
        switch (that.timeMode) {
          case "new":
            that.minDate = new Date(nowYear, 0, 1)
            break;
          case "defalutYear":
            that.minDate = new Date(nowYear + that.yearDiff, 0, 1)
            break;
          default:
            break;
        }
        // if (this.timeMode == "new") {
        //   let nowDate = new Date()
        //   let nowYear = nowDate.getFullYear()
        //   this.minDate = new Date(nowYear - 1, 0, 1)
        // }
      },
      clearValue(){
        this.$emit('input', "")
      }
    },
    beforeMount() {
      if (this.timeNow) {
        console.log(this.timeNow);
        this.selectValue = new Date()
        this.onConfirm(this.selectValue)
      }
    },
    mounted: function() {
      this.setTimeRange()
    }
  }
</script>

<style>
</style>
